import React, { useState, useCallback, useEffect } from "react";
// import closeFilter from '../../../assets/images/filter_colse.png';
import {
  addLineBreaks,
  formatDateToMMDDYYYY,
  parseDateFromString,
  SAVINGS,
  SPENDING,
} from "../../../utils";
import { useTranslation } from "react-i18next";
// import SearchInput from '../../Search';
// import FilterIcon from '../../../assets/images/Filter.png';
import { useDispatch, useSelector } from "react-redux";

// import logFirebaseEvents from '../../LogFirebaseEvents';
import { appTheme } from "../../../helpers/utils/Utils";
import CustomBarChart from "../../OnBoard/Signup/SpendAndLoad/CustomBarChart";
import dotLoad from "../../../assets/kudzu-plus-images/dotLoad.png";
import dotSpend from "../../../assets/kudzu-plus-images/dotSpend.png";
import smiOneFilterClose from "../../../assets/kudzu-plus-images/crossIcon.png";
import downArrow from "../../../assets/kudzu-plus-images/downArrow.png";
import moment from "moment";

const SmiOneSpendsAndLoad = ({
  filterClose,
  monthNumber,
  selectedWeek,
  spendLoadData,
  handleSelectedValue,
  days,
  showSelectedType
}) => {
  const currentPath = window.location.pathname;
  const currentDate = new Date();
  const minDate = new Date(currentDate);
  minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
  const maxDate = new Date(); // Maximum date is today
  const { t } = useTranslation();
  const [labelsShow, setLabelsShow] = useState(true);
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("6 Months");
  const [isYourRight, setIsYourRight] = useState(false);

  // const options = ["6 Months", "3 Months", "1 Month", "1 Week", "1 Day"];
  const options = [
    {
      id: 1,  
      name: '6 Months',
      monthValue: moment().subtract(6, 'months').format('YYYY-MM-DD'),
      selected : 'Monthly'
    },
    {
      id: 2,
      name: '3 Months',
      monthValue: moment().subtract(3, 'months').format('YYYY-MM-DD'),
      selected : 'Monthly'
    },
    {
      id: 3,
      name: '1 Month',
      monthValue: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      selected : 'Month'
    },
    {
      id: 4,
      name: '1 Week',
      monthValue: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      selected : 'Week'
    },
    {
      id: 5,
      name: '1 Day',
      monthValue: moment().format('YYYY-MM-DD'),
      selected : 'Day'
    }
  ]
 

  const YourRightText = () => {
    return (
      <div
        className="bg-[#324261] rounded-bl-card-tr
         sm:py-12 pt-12 pb-0 md:px-16 sm:px-[2.5rem] text-white" 
      >
        <span>
          <img
            src={smiOneFilterClose}
            alt="close filter"
            className="sm:px-0 px-[2.5rem] float-right cursor-pointer md:w-[15px] w-[90px]"
            onClick={() => setIsYourRight(false)}
          />
        </span>
        <p className="sm:px-0 mt-4 mb-[40px] px-[2.5rem] font-hanken-grotesk text-[14px] font-semibold uppercase text-[var(--text-clr-transactions-cancel)]
             leading-6 tracking-[3px]"
        ></p>
        <div>
          <p className="font-serif-pro mt-4 px-[2.5rem] md:text-[28px] font-normal text-[20px] ">
            {t("your_right")}
          </p>
        </div>
        <div className="font-hanken-grotesk px-[2.5rem] text-[14px] md:text-[16px] font-normal">
          <p className=" mt-[14px]">
            {t("in_case_of_errors")}
          </p>
          <p className=" mt-[14px]">
            {t("call_us")}
          </p>
          <p className=" mt-[14px]">
            {addLineBreaks(t("you_will_need"))}
          </p>
          <p className=" mt-[14px]">
            {t("2why_you_believe")}
          </p>
          <p className=" mt-[14px]">
            {t("3Spproximtely_when")}
          </p>
          <p className=" mt-[14px]">
            {t("if_you_tell_us")}
          </p>
          <p className=" mt-[14px]">
            {t("for_errors")}
          </p>
          <p className=" mt-[14px] pb-[30px]"> 
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
    {isYourRight ? YourRightText() : (
          <div
          className="bg-[#324261] rounded-bl-card-tr
             sm:py-12 pt-12 pb-0 md:px-16 sm:px-[2.5rem]"
        >
          <span>
            <img
              src={smiOneFilterClose}
              alt="close filter"
              className="sm:px-0 px-[2.5rem] float-right cursor-pointer md:w-[16px] w-[96px]"
              onClick={filterClose}
            />
          </span>
          <p
            className="sm:px-0 mt-4 mb-[40px] px-[2.5rem] font-hanken-grotesk text-[14px] font-semibold uppercase text-[var(--text-clr-transactions-cancel)]
                 leading-6 tracking-[3px]"
          >
            {" "}
          </p>
          <div>
            <p className="font-serif-pro px-[2.5rem] text-[var(--text-clr-transactions)] font-normal text-white text-[28px] ">
              {t("spend_loads")}
            </p>
          </div>
    
          <div className="relative px-[2.5rem] font-[500] inline-block text-left mt-10">
            <button
              onClick={() => {
                setIsOpen(!isOpen);
              }}
              className={`w-[135px] ${
                isOpen ? "border-b-0 rounded-b-none" : ""
              } border-2 border-[#3C66FF] text-white py-3 px-4 rounded-3xl flex justify-between items-center`}
            >
              <span className="text-[14px]">{selectedOption}</span>
              <img src={downArrow} className="w-[14px]" alt="" />
            </button>
    
            {isOpen && (
              <div className="absolute w-[135px] mt-[-10px] border-t-0 rounded-t-none border-2 rounded-3xl border-[#3C66FF] shadow-lg z-10">
                <ul className="py-1 text-white">
                  {options.map((option, index) => (
                    <li
                      key={index}
                      className="px-4 py-1 cursor-pointer hover:bg-blue-500"
                      onClick={() => {
                        setSelectedOption(option.name);
                        handleSelectedValue(option);
                        setIsOpen(false);
                      }}
                    >
                      {option.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
    
          <div className="px-[1.5rem] md:px-[2.5rem] flex justify-center items-center">
            <div className="w-[600px] pt-10">
              <div className="sm:pt-0 md:pt-10"></div>
              <div className=" pt-10">
                <div className="flex justify-center items-center">
                  <CustomBarChart monthNumber={monthNumber} selectedWeek={selectedWeek} showSelectedType={showSelectedType} days={days} selectedOption={selectedOption} data={spendLoadData} width={600} height={300} />
                </div>
                <div className="border-b-2 border-[#4B70B9] -mt-12 md:mt-0 sm:w-[600px] w-full h-0 md:h-[30px]"></div>
                <div className="flex flex-row gap-[5.25rem] mt-[3.25rem]">
                  <div className="flex gap-3">
                    <img src={dotSpend} alt="incomplete" className="w-2 h-2 mt-2" />
                    <p className="text-[#A3CEBB] font-hanken-grotesk leading-[26px] font-semibold">
                      {t("total_spend")}
                    </p>
                  </div>
                  <div className="flex gap-3">
                    <img src={dotLoad} alt="incomplte" className="w-2 h-2 mt-2" />
                    <p className="text-[#779CE5] font-hanken-grotesk leading-[26px] font-semibold">
                      {t("total_Load")}
                    </p>
                  </div>
                </div>
                <p className="py-20 text-[#94C3E8] cursor-pointer font-hanken-grotesk font-semibold sm:text-[14px] md:text-[14px]"  onClick={() => { setIsYourRight(true)}} >
                  {t("your_right")}
                </p>
                
              </div>
            </div>
          </div>
        </div>
    )}
    </>

  );
};

export default SmiOneSpendsAndLoad;
